import store from "../store/index";
import { LANGUAGE } from "../store/mutation-types";

/**
 * Created by akrio on 2018/4/29.
 */
export const mergeOptions = function ($vm, options) {
  const defaults = {};
  for (let i in $vm.$options.props) {
    if (i !== "value") {
      defaults[i] = $vm.$options.props[i].default;
    }
  }
  const _options = Object.assign({}, defaults, options);
  for (let i in _options) {
    $vm[i] = _options[i];
  }
};

/**
 * 计算语言是否为right to left
 */
export function languageDirectionRtl() {
  const rtlLanguages = ["ar"];
  const language = store.getters[LANGUAGE];
  if (rtlLanguages.find((l) => l === language)) {
    // 直接设置body style rtl
    document.body.classList.add("rtl");
    return true;
  } else {
    document.body.classList.remove("rtl");
    return false;
  }
}

/**
 * 格式化日期
 * @param date 日期格式化
 * @param format 格式化格式
 */
export function dateFormat({ date, format }) {
  // 判断当前语言是不是中文
  const language = store.getters[LANGUAGE] || "en";
  // 如果是中文环境
  if (language.substr(0, 2) === "zh") {
    if (format === "MMM DD, YYYY") {
      return date.format("YYYY年MMMD日");
    } else if (format === "MMMM DD, YYYY") {
      return date.format("YYYY年MMMMD日");
    }
  } else {
    return date.format(format);
  }
}
